<div class="row justify-content-center bgDiv">
	<div class="col-11">
		<p>
		  final-design-proposal works!
		</p>
	</div>
</div>


// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/customer/final-design-proposal/final-design-proposal.component.html